module.exports = __webpack_public_path__ + "static/media/clem-onojeghuo.216ef03c.jpg";